import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { RegistrationService } from 'src/app/services/registration-service/registration.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { StartUpService } from 'src/app/services/start-up-service/start-up.service';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-registry-confirm',
    templateUrl: './registry-confirm.component.html',
    styleUrls: ['./registry-confirm.component.css'],
    standalone: false
})
export class RegistryConfirmComponent implements OnInit {
    loading: boolean = false;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private registrationService: RegistrationService,
        private dialogService: DialogService,
        private authService: AuthService,
        private startUpService: StartUpService,
        private storageService: UserLocalSelectionService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.route.queryParamMap.subscribe((params) => {
            const token = params.get('code');
            this.registrationService.confirmRegistration(token).subscribe(
                (_) => {
                    const modalResult = this.dialogService.openDialog(
                        'Registrierung abgeschlossen',
                        'Sie werden jetzt weiter geleitet.'
                    );
                    modalResult.subscribe((_) => {
                        this.loading = true;
                        this.cdRef.detectChanges();
                        let loginCode = window.location.href;
                        if(loginCode.includes("loginCode=")) {
                            let pkceVerifier = loginCode.split("codeVerifier=")[1];
                            let authorization_code = loginCode.split("&codeVerifier=")[0].split("loginCode=")[1];
                            setTimeout(() => {
                                this.authService.loginWithCode(authorization_code, pkceVerifier).subscribe(
                                    async (result) => {
                                    if (typeof result === 'number') {
                                        await this.startUpService.handleLogin();
                                        this.router.navigate(['/registry/confirmation']);
                                    }
                                });
                            }, 2000);
                        } else  {
                            this.dialogService.openLoginDialog().subscribe((result) => {
                                if (result === 'success') {
                                    this.router.navigate(['/registry/confirmation']);
                                }
                        });
                        }
                    });
                },
                (errorObj) => {
                    this.loading = false;
                    this.handleConfirmationError(errorObj.error);
                }
            );
        });
    }

    handleConfirmationError(error) {
        console.error('Registrierungsbestätigung fehlgeschlagen:', error);
        const modalResult = this.dialogService.openDialog(
            'Registrierung fehlgeschlagen',
            'Die Bestätigung Ihres Kontos ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.'
        );

        modalResult.subscribe(() => {
            this.router.navigate(['/']);
        });
    }
}
